import Vue from 'vue'
import Vuex from 'vuex'
import authorization from './modules/authorization'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authorization,
    user
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js